import axios from 'axios';

export default async function addSensibleWord({
  accessToken,
  companyId,
  sensibleWords,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANIES_API_URL}/add-sensible-word/${companyId}`,
      { sensible_words: sensibleWords },
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  }
}
